var exports = {
  "container-display--none": "xe564cbfb--3f9b07--container-display--none",
  "container-display--block": "xe564cbfb--3f9b07--container-display--block",
  "container-display--inline": "xe564cbfb--3f9b07--container-display--inline",
  "container-display--inline-block": "xe564cbfb--3f9b07--container-display--inline-block",
  "container-display--flex": "xe564cbfb--3f9b07--container-display--flex",
  "container-display--inline-flex": "xe564cbfb--3f9b07--container-display--inline-flex",
  "container-width--auto": "xe564cbfb--3f9b07--container-width--auto",
  "container-width--inherit": "xe564cbfb--3f9b07--container-width--inherit",
  "container-width--wide": "xe564cbfb--3f9b07--container-width--wide",
  "element": "xe564cbfb--3f9b07--element",
  "element-reverse": "xe564cbfb--3f9b07--element-reverse",
  "offset": "xe564cbfb--3f9b07--offset",
  "icon": "xe564cbfb--3f9b07--icon",
  "container-display_mobile--none": "xe564cbfb--3f9b07--container-display_mobile--none",
  "container-display_mobile--block": "xe564cbfb--3f9b07--container-display_mobile--block",
  "container-display_mobile--inline": "xe564cbfb--3f9b07--container-display_mobile--inline",
  "container-display_mobile--inline-block": "xe564cbfb--3f9b07--container-display_mobile--inline-block",
  "container-display_mobile--flex": "xe564cbfb--3f9b07--container-display_mobile--flex",
  "container-display_mobile--inline-flex": "xe564cbfb--3f9b07--container-display_mobile--inline-flex",
  "container-display_phone--none": "xe564cbfb--3f9b07--container-display_phone--none",
  "container-display_phone--block": "xe564cbfb--3f9b07--container-display_phone--block",
  "container-display_phone--inline": "xe564cbfb--3f9b07--container-display_phone--inline",
  "container-display_phone--inline-block": "xe564cbfb--3f9b07--container-display_phone--inline-block",
  "container-display_phone--flex": "xe564cbfb--3f9b07--container-display_phone--flex",
  "container-display_phone--inline-flex": "xe564cbfb--3f9b07--container-display_phone--inline-flex",
  "container-display_tablet--none": "xe564cbfb--3f9b07--container-display_tablet--none",
  "container-display_tablet--block": "xe564cbfb--3f9b07--container-display_tablet--block",
  "container-display_tablet--inline": "xe564cbfb--3f9b07--container-display_tablet--inline",
  "container-display_tablet--inline-block": "xe564cbfb--3f9b07--container-display_tablet--inline-block",
  "container-display_tablet--flex": "xe564cbfb--3f9b07--container-display_tablet--flex",
  "container-display_tablet--inline-flex": "xe564cbfb--3f9b07--container-display_tablet--inline-flex",
  "container-display_desktop_max--none": "xe564cbfb--3f9b07--container-display_desktop_max--none",
  "container-display_desktop_max--block": "xe564cbfb--3f9b07--container-display_desktop_max--block",
  "container-display_desktop_max--inline": "xe564cbfb--3f9b07--container-display_desktop_max--inline",
  "container-display_desktop_max--inline-block": "xe564cbfb--3f9b07--container-display_desktop_max--inline-block",
  "container-display_desktop_max--flex": "xe564cbfb--3f9b07--container-display_desktop_max--flex",
  "container-display_desktop_max--inline-flex": "xe564cbfb--3f9b07--container-display_desktop_max--inline-flex",
};

module.exports = exports;
